<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="flex">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="showEdit"
          >创建代理</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="total"
        :hasPagionation="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:account_count="{ row }">
          <el-button type="text" @click="showAccountDialog(row)"
            >{{ row.account_count }}个</el-button
          >
        </template>
        <template v-slot:company_count="{ row }">
          <el-button type="text" @click="showCompanyDialog(row)"
            >{{ row.company_count }}家</el-button
          >
        </template>
        <template v-slot:action="{ row }">
          <el-button type="text" class="delBtn" @click="handleDelete(row)"
            >删除</el-button
          >
        </template>
      </VTable>
    </div>

    <edit ref="edit" @refresh="getTable"></edit>
    <account-dialog ref="accountDialog" @refresh="getTable"></account-dialog>
    <company-dialog ref="companyDialog"></company-dialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Edit from "./components/Edit.vue";
import AccountDialog from "./components/AccountDialog.vue";
import CompanyDialog from "./components/CompanyDialog.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "CompanyAgentList",
  mixins: [mixinTable],
  components: {
    VTable,
    Edit,
    AccountDialog,
    CompanyDialog,
  },
  data() {
    return {
      field: [
        { name: "name", label: "代理人员", hidden: false },
        { name: "account", label: "联系电话", hidden: false },
        { name: "area_str", label: "代理区域", hidden: false },
        { name: "account_count", label: "代理账号", hidden: false },
        { name: "company_count", label: "入驻企业", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false },
        { name: "creator_str", label: "创建人", hidden: false },
        { name: "action", label: "操作", width: "100", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      total: 0,
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/companyAgent/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    showEdit() {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom = null;
    },
    showAccountDialog(row) {
      let dom = this.$refs.accountDialog;
      dom.toggle(true, row);
      dom = null;
    },
    showCompanyDialog(row) {
      let dom = this.$refs.companyDialog;
      dom.toggle(true, row);
      dom = null;
    },
    handleDelete(row) {
      this.$confirm("确认删除该企业代理？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "danger",
      })
        .then(() => {
          this.$http
            .post("/admin/companyAgent/delete", { id: row.id })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("删除成功！");
                this.getTable();
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>